import type { CompanyProfile, CustomerProfile, Quote } from '../types';

interface DocumentPartiesProps {
  company: CompanyProfile;
  quote: Quote;
}

function DocumentParty({ label, party, fallbackName }: { label: string; party: CustomerProfile; fallbackName: string }) {
  const rows = [
    { label: 'ที่อยู่', value: party.address?.trim() || '—' },
    { label: 'เลขผู้เสียภาษี', value: party.taxId?.trim() },
    { label: 'สำนักงาน', value: party.type !== 'individual' && party.taxId?.trim()
      ? party.branchType === 'branch' ? `สาขา ${party.branchCode?.trim() || '—'}` : 'สำนักงานใหญ่'
      : '' },
    { label: 'ผู้ติดต่อ', value: party.contactName?.trim() },
    { label: 'โทรศัพท์', value: party.phone?.trim() },
    { label: 'อีเมล', value: party.email?.trim() },
  ].filter(row => row.value);

  return <section className="document-party" aria-label={label === 'จาก' ? 'ข้อมูลผู้ออกเอกสาร' : 'ข้อมูลลูกค้า'}>
    <span className="doc-label">{label}</span>
    <h3>{party.name?.trim() || fallbackName}</h3>
    <dl className="document-party-details">
      {rows.map(row => <div className="document-party-row" key={row.label}>
        <dt>{row.label}</dt><dd>{row.value}</dd>
      </div>)}
    </dl>
  </section>;
}

export function DocumentParties({ company, quote }: DocumentPartiesProps) {
  const customer: CustomerProfile = {
    type: quote.customerType, name: quote.customerName, address: quote.customerAddress,
    taxId: quote.customerTaxId, branchType: quote.customerBranchType, branchCode: quote.customerBranchCode,
    contactName: quote.customerContactName, phone: quote.customerPhone, email: quote.customerEmail,
  };
  return <div className="document-parties">
    <DocumentParty label="จาก" party={company} fallbackName="ผู้ออกเอกสาร" />
    <DocumentParty label="ถึง" party={customer} fallbackName="ชื่อลูกค้า" />
  </div>;
}
